import WatchVideo from "./watch-video";

export default WatchVideo;